import {
    FETCH_CATEGORIES,
    FETCH_CATEGORIES_SUCCESS,

    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    ADD_CATEGORY_FAIL,

    UPDATE_CATEGORY,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_FAIL,

    DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAIL
} from '../actions/CategoryActions';

const INITIAL_STATE = {
    categories: [],
    isCategoryLoading: false,
    errorMessage: ''
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_CATEGORIES:
            return { ...state, isCategoryLoading: true };
        case FETCH_CATEGORIES_SUCCESS:
            return { ...state, isCategoryLoading: false, categories: action.payload };

        case ADD_CATEGORY:
        case UPDATE_CATEGORY:
        case DELETE_CATEGORY:
            return { ...state, isCategoryLoading: true, errorMessage: '' };
        case ADD_CATEGORY_SUCCESS:
        case UPDATE_CATEGORY_SUCCESS:
        case DELETE_CATEGORY_SUCCESS:
            return { ...state, isCategoryLoading: false, errorMessage: '' };
        case ADD_CATEGORY_FAIL:
        case UPDATE_CATEGORY_FAIL:
        case DELETE_CATEGORY_FAIL:
            return { ...state, isCategoryLoading: false, errorMessage: action.payload };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CategoryReducer.js